module.exports = __webpack_public_path__ + "img/domba.43bc5a3d.png";